import Model from "../../Model.js";

/**
 * Abstract class for the validation results sent by the server.
 *
 * @abstract
 * @param {string} spec.message - Result message
 * @param {chartOfAccounts} spec.chartOfAccounts - Chart of accounts to which the
 * error is related
 */
export default class AbstractChartOfAccountsValidationResult extends Model {
	constructor(spec) {
		super(spec);
		this._message = spec.message;
		this._chartOfAccounts = spec.chartOfAccounts;
	}

	getMessage() {
		return this._message;
	}

	isDefault() {
		return false;
	}

	transformMaterializationData(data, context) {
		data.chartOfAccounts = context.chartOfAccounts;
	}
}
